import { render } from "./DocVersionPartyCom.vue?vue&type=template&id=74b51490"
import script from "./DocVersionPartyCom.vue?vue&type=script&lang=js"
export * from "./DocVersionPartyCom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__